import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15fa8015"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver fw list-query-header a-table" }
const _hoisted_2 = {
  key: 0,
  class: "ub ub-pe fw",
  style: {"padding-bottom":"10px","box-sizing":"border-box"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      layout: "inline",
      labelAlign: "right",
      class: "fw list-query-header-form",
      style: {"position":"relative"},
      labelCol: { style: 'width: ' + _ctx.labelWidth + 'px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["ub form-item-div", _ctx.collapsed ? 'collapsed' : '']),
          style: _normalizeStyle({
          width: _ctx.collapsed ? _ctx.listQueryFormWidth + 'px' : '100%',
          'flex-wrap': 'wrap',
        })
        }, [
          _renderSlot(_ctx.$slots, "form", {
            appendToParent: _ctx.collapsed ? 'append-to-table' : 'append-to-body'
          }, undefined, true),
          (!_ctx.ifIsSignleRow)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.collapsed)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      class: "list-query-header-search absolute-form-item-bottom"
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "search", {}, () => [
                          _createVNode(_component_Search, {
                            loading: _ctx.loading,
                            collapsed: _ctx.collapsed,
                            searchText: _ctx.searchText,
                            resetText: _ctx.resetText,
                            showCollapsed: _ctx.showCollapsed,
                            "onUpdate:showCollapsed": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showCollapsed) = $event)),
                            onReset: _ctx.reset,
                            onSearch: _ctx.search,
                            onToggleFn: _ctx.toggleFn
                          }, null, 8, ["loading", "collapsed", "searchText", "resetText", "showCollapsed", "onReset", "onSearch", "onToggleFn"])
                        ], true)
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 6),
        (!_ctx.ifIsSignleRow)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.collapsed)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    class: "list-query-header-search absolute-form-item-top",
                    style: {"margin-right":"0px !important"}
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "search", {}, () => [
                        _createVNode(_component_Search, {
                          loading: _ctx.loading,
                          searchText: _ctx.searchText,
                          resetText: _ctx.resetText,
                          collapsed: _ctx.collapsed,
                          showCollapsed: _ctx.showCollapsed,
                          "onUpdate:showCollapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showCollapsed) = $event)),
                          onReset: _ctx.reset,
                          onSearch: _ctx.search,
                          onToggleFn: _ctx.toggleFn
                        }, null, 8, ["loading", "searchText", "resetText", "collapsed", "showCollapsed", "onReset", "onSearch", "onToggleFn"])
                      ], true)
                    ]),
                    _: 3
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["labelCol"]),
    (_ctx.ifIsSignleRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "search", {}, () => [
            _createVNode(_component_Search, {
              loading: _ctx.loading,
              collapsed: _ctx.collapsed,
              searchText: _ctx.searchText,
              resetText: _ctx.resetText,
              showCollapsed: _ctx.showCollapsed,
              "onUpdate:showCollapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCollapsed) = $event)),
              onReset: _ctx.reset,
              onSearch: _ctx.search,
              onToggleFn: _ctx.toggleFn
            }, null, 8, ["loading", "collapsed", "searchText", "resetText", "showCollapsed", "onReset", "onSearch", "onToggleFn"])
          ], true)
        ]))
      : _createCommentVNode("", true)
  ]))
}